import React from 'react'

export default function ErrorComponent() {

  return <div className='tab-content'>A server error has occurred and the data cannot load at this time. Please try again later.</div>

}